<template>
    <div class="common-layout">
        <el-container>
            <el-header>
                <Header></Header>
            </el-header>
            <el-container>
                <el-aside width="380px">
                    <div class="lay_left_box">
                        <el-row>
                            <el-col :span="6">
                                <el-image class="avatar" :src="userInfo.avatar" :fit="fit" />
                            </el-col>
                            <el-col class="user_info" :span="18">
                                <span style="font-weight: bold;color:#000;font-size:16px">{{ userInfo.name }}</span>

                                <span>{{ userInfo.username }}</span>
                                <span>{{ userInfo.school_name }}</span>
                            </el-col>
                        </el-row>
                        <div class="info_menu">
                            <el-menu
                                :default-active="activeIndex"
                                class="el-menu-vertical-demo"
                                @select="handleSelect"
                            >
                                <el-menu-item index="1" @click="router.push( userInfo.type == 1 ? '/plan' : '/stuplan')">

                                    <el-icon><Monitor /></el-icon>
                                    <span>班级管理</span>
                                </el-menu-item>
                                <el-menu-item index="2" @click="router.push( userInfo.type == 1 ? '/task' : '/stutask')">
                                    <el-icon><Promotion /></el-icon>
                                    <span>任务管理</span>
                                </el-menu-item>
                                <el-menu-item index="3" @click="router.push( userInfo.type == 1 ? '/exam' : '/stuexam')">
                                    <el-icon><AlarmClock /></el-icon>
                                    <span>考试管理</span>
                                </el-menu-item>
                                <el-menu-item index="4" v-if="userInfo.type == 1" @click="router.push('/studyplan')">
                                    <el-icon><Document /></el-icon>
                                    <span>自主学习统计</span>
                                </el-menu-item>
                                <el-menu-item index="4" v-if="userInfo.type == 0" @click="router.push('/study')">
                                    <el-icon><Document /></el-icon>
                                    <span>学习记录</span>
                                </el-menu-item>
                                <el-menu-item index="5" @click="router.push( userInfo.type == 1 ? '/message' : '/stumessage')">
                                    <el-icon><Message /></el-icon>
                                    <el-badge :value="localUnreadCount" class="item">
                                        <span>消息管理</span>
                                    </el-badge>
                                </el-menu-item>
                                
                                <el-menu-item index="6" @click="router.push( userInfo.type == 1 ? '/info' : '/stufinfo')">
                                    <el-icon><UserFilled /></el-icon>
                                    <span>个人信息</span>
                                </el-menu-item>
                            </el-menu>
                        </div>

                        <!-- <div class="info_week_box">
                            <div class="info_overview">
                                <span class="left">教学概览</span>
                                <span class="right">本周</span>
                            </div>
                            <div class="info-grid-container">
                                
                                <div style="background: #F7FCFF;" class="info-grid-item">
                                    <span class="overview_name">班级总数</span>
                                    <span class="overview_number">2</span>
                                    <el-row class="overview_data">
                                        <el-col :span="6">
                                            <el-icon size="18" style="float: right;margin-top: 7px;"><Top /></el-icon>
                                        </el-col>
                                        <el-col :span="18">
                                            <span>2个</span>
                                            <span>
                                                ( <el-icon><Top /></el-icon> 10% )
                                            </span>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div style="background: #F0FDF4;" class="info-grid-item">
                                    <span class="overview_name">活跃人数</span>
                                    <span style="color:#53C41C" class="overview_number">2</span>
                                    <el-row class="overview_data">
                                        <el-col :span="6">
                                            <el-icon size="18" style="float: right;margin-top: 7px;"><Top /></el-icon>
                                        </el-col>
                                        <el-col :span="18">
                                            <span>2 人</span>
                                            <span>
                                                ( <el-icon><Top /></el-icon> 10% )
                                            </span>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div style="background: #EFF6FF;" class="info-grid-item">
                                    <span class="overview_name">任务完成人数</span>
                                    <span style="color:#2563EB" class="overview_number">2</span>

                                    <el-row class="overview_data">
                                        <el-col :span="6">
                                            <el-icon size="18" style="float: right;margin-top: 7px;"><Top /></el-icon>
                                        </el-col>
                                        <el-col :span="18">
                                            <span>2人</span>
                                            <span>
                                                ( <el-icon><Top /></el-icon> 10% )
                                            </span>
                                        </el-col>
                                    </el-row>
                                </div>
                                <div style="background: #FAF5FF;" class="info-grid-item">
                                    <span class="overview_name">平均成绩</span>
                                    <span class="overview_number" style="color:#9333EA">2</span>
                                    <el-row style="color:#FE6063" class="overview_data">
                                        <el-col :span="6">
                                            <el-icon size="18" style="float: right;margin-top: 7px;"><Top /></el-icon>
                                        </el-col>
                                        <el-col :span="18">
                                            <span>2 分</span>
                                            <span>
                                                ( <el-icon><Top /></el-icon> 10% )
                                            </span>
                                        </el-col>
                                    </el-row>
                                </div>
                            </div>
                        </div> -->

                        <div v-if="userInfo.type == 1" class="info_echart">
                            <span style="font-size:18px;font-weight:700;">学生活动趋势</span>
                            <div id="main" ref="chart" style="width: 100%; height: 300px;"></div>
                        </div>
                    </div>
                    
                </el-aside>
                <el-main style="padding-top:0">
                    <slot></slot>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import Header from '@/../unit/common/Header.vue'
import * as echarts from 'echarts'
import { activeStatistics,info } from '@/api/teach'
import { unread } from '@/api/user'

import { onMounted,ref,onBeforeUnmount, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

export default {
    name:'LayoutComponentBase',
    components:{
        Header
    },


    setup(){
        const router = useRouter()
        const route = useRoute()
        const fit = ref('fill')
        const activeIndex = ref('1')
        const observer = ref(null)
        //const localUnreadCount = ref(props.unread_count ?? localStorage.getItem('message_count'))
        const userInfo = ref({})
        const localUnreadCount = ref(0)
        let myChart = null;
        let resizeHandler = null;

        const handleSelect = (index)=>{
            localStorage.setItem('activeIndex',index)
            activeIndex.value = index
        }

        const getUserInfo = async () =>{
            const res = await info();
            userInfo.value = res.data
        }


        const initChart = async (data)=>{
            if (myChart) {
                myChart.dispose();
            }
            const chartDom = document.getElementById('main');
            if (!chartDom) {
                console.error('未找到图表容器');
                return;
            }

            myChart = echarts.init(chartDom);

            const option = {
                grid: {
                    left: '0',
                    right: '4%',
                    bottom: '3%',
                    top: '10%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: data,
                        type: 'line'
                    }
                ]
            };

            myChart.setOption(option);
        }


        // 获取数据
        const getunread = async () => {
      
            const res = await unread();
            localUnreadCount.value = res.data.data

        };

        
        // 获取数据
        const loadLeftData = async () => {
            try {
                const res = await activeStatistics();
                
                if (res && res.data) {

                    setTimeout(()=>{
                        initChart(res.data);
                    },300)
                    
                }
            } catch (error) {
                console.error('数据加载失败:', error);
                // 保持默认数据显示
            }
        };

        onMounted(() => {
            getUserInfo();
            activeIndex.value = '1'
            getunread()
            loadLeftData();
            //localUnreadCount.value = localStorage.getItem('message_count');
            // 窗口大小变化处理
            resizeHandler = () => {
                if (myChart) myChart.resize();
            };
        });

        onBeforeUnmount(() => {
            // 清理工作
            if (resizeHandler) {
                window.removeEventListener('resize', resizeHandler);
            }
            if (myChart) {
                myChart.dispose();
                myChart = null;
            }
        });

        watch(() => route.path, (path) => {
            if(localStorage.getItem('activeIndex')){
                activeIndex.value = localStorage.getItem('activeIndex')
                return
            }
            if(path === '/plan') activeIndex.value = '1'
            if(path === '/task') activeIndex.value = '2'
            if(path === '/exam') activeIndex.value = '3'
            if(path === '/message') activeIndex.value = '4'
            if(path === '/info') activeIndex.value = '5'

        },{immediate:true})



        
        return{
            fit,
            activeIndex: activeIndex.value,
            observer,
           localUnreadCount,
            handleSelect,
            getUserInfo,
            getunread,
            router,
            userInfo

        }
    }

}
</script>
<style scoped>
.el-main{
    position: relative !important;

}
.common-layout :deep(.el-header){
    padding: 0;
    height: auto;
}
.common-layout :deep(.el-aside){
    box-sizing: border-box;
}
.lay_left_box{
    width: 100%;
    min-height: calc(100vh - 170px);
    background: #fff;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.15);
    box-sizing: border-box;
    padding: 20px;
}
.lay_left_box :deep(.el-row){
    padding-bottom: 20px;
    border-bottom: 1px #f3f4f6 solid;
}
.avatar{
    width: 74px;
    height: 74px;
    border-radius: 50px;
    float: left;
}
.user_info span{
    width: 100%;
    display: inline-block;
    text-align: left;
    font-size: 14px;
    line-height: 25px;
    text-indent: 10px;
}
.info_menu{
    display: inline-block;
    width: 100%;
    margin-top: 20px;
}
.info_menu :deep(.el-menu){
    border: none;
}
.info_menu :deep(.el-menu-item.is-active){
    background: #409EFF;
    color: #fff;
    border-radius: 5px;
}
.info_week_box{
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
    display: inline-block;
    margin-top: 30px;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.15);
    transition: transform 0.3s ease;
}
.info-grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px; /* 设置间距为20px */
    width: 100%;
}
.info-grid-item {
    padding: 10px;
    border-radius: 4px;
    
}
.info_week_box:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.15);
}
.info_overview{
    width: 100%;
    display: inline-block;
    font-size: 14px;
    margin-bottom: 15px;
}
.info_overview .left{
    float: left;
    font-weight: 700;
}
.info_overview .right{
    float: right;
    color: #409EFF;
}
.overview_name{
    width: 100%;
    display: inline-block;
    font-size: 12px;
    text-align: center;
}
.overview_number{
    width: 100%;
    display: inline-block;
    text-align: center;
    font-weight: 700;
    font-size: 20px;
    color: #54A9FF;
    margin-top: 10px;
}
.overview_data{
    color: #53C41C;
    font-size: 12px;
    margin-top: 10px;
}
.overview_data span{
    display: inline-block;
    width: 100%;
    text-align: center;
}
.info_echart{
    margin-top: 30px;
}
.info_echart span{
    font-size: 14px;
    display: inline-block;
    text-align: left;
    width: 100%;
}
.info_menu :deep(.el-badge__content.is-fixed){
    top: 28px;
    right: -8px;

}
</style>